<template>
    <div class="mb-5 price price-list" :class="{
        'selected': 'no-protection' === selectedPackage
    }">
        <label
            for="no-protection"
            class="d-block float-none cursor-pointer font-size-5 m-0"
            :class="{
                'bg-gray-100 border-light': 'no-protection' !== selectedPackage
            }"
        >
            <div class="d-flex align-items-center">
                <div>
                    <b-form-radio
                        id="no-protection"
                        name="packages"
                        value="no-protection"
                        @input="$emit('input', selectedPackage)"
                        v-model="selectedPackage"
                    />
                </div>

                <div>
                    <h3 class="font-weight-normal">
                        No Protection Package
                    </h3>

                    <p class="mb-0">
                        <slot name="no-protection-messge">
                            Send invite only.
                        </slot>
                    </p>
                </div>
            </div>
        </label>
    </div>
</template>

<script>
import './Price.scss';
export default {
    name: 'NoProtection',
    data: () => ({
        selectedPackage: null,
    }),
    props: {
        value: {
            type: String
        }
    },
    watch: {
        value: {
            immediate: true,
            handler() {
                this.selectedPackage = this.value;
            }
        }
    }
}
</script>